<template>
  <div class="manager_dashboard">
    <user-menu />
    <div class="wrapper">
      <admin-sidebar-menu v-if="admin" />
      <div class="content-wrapper">
        <div class="container-wrapper center">
          <div>
            <h3 class="d-inline heading">Account</h3>
          </div>
          <div class="heading-seperator"></div>
          <div style="clear: both" class="margin-bottom-10"></div>
          <div v-show="loading" class="loading_show"><div class="spinner-border text-danger"></div></div>
          <div class="dash_container_wrapper col-lg-12 float-left" v-for="account_list in account_lists">
            <div class="account_link ">
              <span class="cursor-pointer" v-if="account_list.school_flag == 1" @click="setUserAccount(account_list.id, '/student-account-tasklists/')">
                {{ account_list.company_name }}
              </span>
              <span class="cursor-pointer" v-if="account_list.school_flag == 0" @click="setUserAccount(account_list.id, '/mentee-account-tasklists/')">
                {{ account_list.company_name }}
              </span>
              <i class="fa fa-angle-right float-right font-20" style="padding-top: 5px;" aria-hidden="true"></i>
            </div>
            <div style="clear: both"></div>
          </div>
          <div style="clear: both"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue/dist/vue.esm';
import UserMenu from '../shared/user_menu.vue';
import router from '../../router/index.js';
import store from '../../store/store.js';
import axios from 'axios';

export default {
  data: function () {
    return {
       loading: false,
       account_lists: [],
    }
  },
  components: {
    UserMenu
  },
  methods: {
     setUserAccount(accountId, path) {
       this.$store.dispatch('set_user_accountid', accountId);
       var url = path + accountId;
       this.navigate(url);
     },
     navigate(path) {
   	  router.push(path);
   	 }
  },
  created: function () {
    this.loading = true;
    axios.get('/mentee/account_lists', {

    })
    .then(response =>  {
      if(response.data.length > 1) {
        this.loading = false;
        this.account_lists = response.data;
        this.$store.dispatch('set_user_accountid', response.data[0].id);
      }
      else {
        this.$store.dispatch('set_user_accountid', response.data[0].id);
        router.push("/student-account-tasklists/" + response.data[0].id + "");
      }
    })
    .catch(function(error) {

    });

  },

}
</script>

<style scoped>
  .dashboard-link a {
    color: #000;
    font-size: 22px;
    line-height: 50px;
  }
  .dashboard-link a:hover {
    color: #000;
    text-decoration: none;
  }
  .account_link {
    font-size: 17px;
    padding-left: 0px;
  }
  .account_link a, .account_link a:hover{
    color: #338ED3;
    text-decoration: none;
  }
  .dash_container_wrapper {
    background-color: #DDD;
    padding-top: 5px;
    height: 40px;
    border: 1px solid #DDD;
    margin-top: 0px;
    border-bottom: 1px solid #BBB;
    text-align: left;
    -webkit-box-shadow: 0px 5px 3px 0px #ccc;  /* Safari 3-4, iOS 4.0.2 - 4.2, Android 2.3+ */
    -moz-box-shadow:    0px 5px 3px 0px #ccc;  /* Firefox 3.5 - 3.6 */
    box-shadow:         0px 5px 3px 0px #ccc;  /* Opera 10.5, IE 9, Firefox 4+, Chrome 6+, iOS 5 */
  }
  .dash_container_wrapper:hover {
    background-color: #CCC;
  }
  .account_link span {
    color: #338ED3;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/student/student_dashboard.vue